/**
 * About Me Detail Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.aboutMeDetailFormatter = function(value, row) {
    let html = '';
    if (row.description) {
        html += row.description;
    }
    return html;
};
